import { render, staticRenderFns } from "./NewCommentIcon.vue?vue&type=template&id=357007d7"
import script from "./NewCommentIcon.vue?vue&type=script&lang=js"
export * from "./NewCommentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports